const utils = {
  /**
   * 数组列表数据处理
   * @param {Array} arr 基准数组
   * @param {Number} colCount 单行列数
   */
  listWith(arr, colCount) {
    let result = [...(arr || [])]
    let remainder = colCount - (result.length % colCount)
    if (remainder < colCount) {
      while (remainder > 0) {
        result.push({ type: 'seat' })
        remainder--
      }
    }
    return result
  },
  /**
  * 简单深拷贝
  * @param {*} data
  */
  deepCopy(data) {
    let result = data
    try {
      result = JSON.parse(JSON.stringify(data))
    } catch (err) {
      console.log(err)
    }
    return result
  },
  /**
   * 日期格式化
   * @param {Date | string | number} date
   * @param {string} format
   */
  formatDate(date, format = 'yyyy-MM-dd hh:mm:ss') {
    if (new Date(date).toString() === 'Invalid Date') return date
    let result = format
    date = new Date(date)
    let dict = {
      'y+': date.getFullYear(),
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    Object.keys(dict).forEach(v => {
      if (new RegExp(`(${v})`).test(result)) {
        if (v === 'y+') {
          result = result.replace(new RegExp(v), dict[v].toString().substr(4 - RegExp.$1.length))
        } else {
          result = result.replace(new RegExp(v), RegExp.$1.length > 1 ? `00${dict[v]}`.substr(dict[v].toString().length) : dict[v])
        }
      }
    })
    return result
  },
  /**
   * 时间格式化
   * @param {number} time
   * @param {string} format
   */
  formatTime(time, format = 'dd天hh小时mm分ss秒') {
    time = parseInt(time) || 0
    let result = format
    let handles = [
      { reg: 'd+', factor: 86400000 },
      { reg: 'h+', factor: 3600000 },
      { reg: 'm+', factor: 60000 },
      { reg: 's+', factor: 1000 },
    ]
    handles.forEach(v => {
      if (new RegExp(`(${v.reg})`).test(result)) {
        let val = Math.floor(time / v.factor)
        time = time % v.factor
        result = result.replace(new RegExp(v.reg), val.toString().padStart(2, 0))
      }
    })
    return result
  },
  /**
   * JSON字符串格式化
   * @param {string} jsonStr
   */
  jsonParse(jsonStr, defaultValue) {
    let result = defaultValue || {}
    if (jsonStr) {
      try {
        result = JSON.parse(jsonStr)
      } catch (err) {
        console.log(err)
        result = defaultValue || {}
      }
    }
    return result
  },
  /**
   * 函数防抖 (只执行最后一次点击)
   * @param fn
   * @param delay
   * @returns {Function}
   * @constructor
   */
  debounce(fn, t) {
    let timer = null
    let delay = t || 500
    return function () {
      let context = this, args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  },

  /**
     * 删除数组中指定元素 
     * @param arr 原数组(续包含数组id)
     * @param 需要删除值的id
     * @returns {Function}
     * @constructor
     */

  removeArrValue(arr, id) {
    if (!arr.length) return false
    return arr.forEach((v, i) => {
      if (v.id === id) {
        arr.splice(i, 1);
      }
    });
  },
 


}

export default utils
